import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams, useLocation} from 'react-router-dom';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {
    Breadcrumbs, Button, Container, Grid, Icon, MenuItem, Paper, TextField,
    Typography,
} from "@mui/material";
import {getPreviousStep, getStepFromUrl, requestApi, showAlertAutoDis} from "../../utils/utils";
import {makeStyles, withStyles} from "@mui/styles";
import ActivityCardView from "../../components/Booking/DayTripBooking/ActivityCardView";
import {useDispatch, useSelector} from "react-redux";
import {getActivityList} from "../../redux/actions/activitiesActions";
import {setStep} from "../../redux/actions/stepActions";
import {useAuthUser, useIsAuthenticated} from "react-auth-kit";
import ReCAPTCHA from "react-google-recaptcha";
import clsx from "clsx";
import DayTripStepper from "../../components/Booking/DayTripBooking/DayTripStepper";
import ActivityOverview from "../../components/Booking/DayTripBooking/ActivityOverview";



const NautilusTextInput = withStyles({
    root: {
        backgroundColor: 'white',
        '& .MuiInputBase-input': {
            fontSize: '1.2rem',
            height: '2em',
        },
        '& .MuiFormLabel-root': {
            fontSize: '1.2rem',
        },
        '& label.Mui-focused': {
            color: '#1ebce7',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#1ebce7',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            // '& fieldset': {
            //     borderColor: 'red',
            // },
            '&:hover fieldset': {
                borderColor: '#1ebce7',
            },
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: '#1ebce7',
                    '& legend': {
                        padding: '3px'
                    }
                }
            },
            '&.Mui-focused .MuiSelect-select fieldset': {
                '& legend': {
                    padding: '0'
                }
            },
        },
    },
})(TextField);
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        lineHeight: 2.5,
        fontSize: '1.4rem',
        backgroundColor: '#00b7f0',
        borderColor: '#00b7f0',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    mainContent: {
        paddingTop: 40
    },
    section1: {
        margin: theme.spacing(3, 2),
    },
    summaryItems: {
        '&:last-child': {
            marginBottom: 24
        }
    }
}));

const initialData = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    city: '',
    country: '',
    guests: '',
    inquiryType: '',
    interest: '',
    comments: '',
    date: new Date()
};

const DayTripInquiryPage = ({history}) => {
    const [inquiryData, setInquiryData] = React.useState(initialData);
    const classes = useStyles();
    const dispatch = useDispatch();
    const {activityId} = useParams(); // <- get activityId from the URL
    const activities = useSelector(state => state.activities);
    const {extra: selectedExtras} = useSelector(state => state.transactions);
    const isAuth = useIsAuthenticated();
    const step = useSelector(state => state.step);
    const prevStep = getPreviousStep(step);
    const prefixUrl = 'booking/day-trips';
    const historyUrl = useHistory();
    const auth = useAuthUser();
    const user = auth(); // fuera de useEffect

    const inquiryOptions = [
        {title:'Regular Day Trip'},
        {title:'Private Day Trip'},
    ];
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const dateParam = searchParams.get('date'); // formato esperado: YYYY-MM-DD

        if (dateParam) {
            const parsedDate = new Date(dateParam);
            if (!isNaN(parsedDate)) {
                setInquiryData(prev => ({
                    ...prev,
                    date: parsedDate.toISOString().split('T')[0] // formatea como YYYY-MM-DD
                }));
            }
        }
    }, [location.search]);

    useEffect(() => {
        if (
            isAuth() &&
            user &&
            inquiryData.firstname === '' &&
            inquiryData.lastname === '' &&
            inquiryData.email === ''
        ) {
            setInquiryData(prev => ({
                ...prev,
                firstname: user.firstName || '',
                lastname: user.lastName || '',
                email: user.email || '',
            }));
        }
    }, [isAuth, user, inquiryData.firstname, inquiryData.lastname, inquiryData.email]);





    useEffect(() => {
        dispatch(getActivityList());
        dispatch(setStep(1));
    }, []);

    const goBack = () => {
        historyUrl.push(`/${prefixUrl}`);
    };

    // Look for the corresponding Activity
    const selectedActivity = Object.values(activities.extra).find(
        (activity) => String(activity.id) === activityId
    );

    const submitInquiry = async () => {
        await requestApi(`/activities/inquiry/${activityId}`, 'POST', {...inquiryData,}, ({data}) => {
            if (data && 'title' in data && 'message' in data) {
                if ('status' in data && data['status'] === 'success')
                    setInquiryData(initialData);
                showAlertAutoDis({
                    title: `<span style="font-size:22px">${data.title}</span>`,
                    html: `<h5>${data.message}</h5>`
                });
            }
        });
        // showAlertAutoDis({
        //     title: 'Inquiry Form Submitted',
        //     text: 'We\'ve received your request, we\'ll get back to you as soon as possible'
        // });
    };

    const handleChange = (event) => {
        setInquiryData({...inquiryData, [event.target.name]: event.target.value});
    };
    const recaptchaRef = useRef();
    const handleForm = (event) => {
        handleChange(event);
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        // const token = await recaptchaRef.current.executeAsync();
        submitInquiry();
    }

    return (
        <div>
        <GuestBar>
            <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                <Typography color="text.primary">Day Trip Bookings</Typography>
            </Breadcrumbs>
        </GuestBar>
            <Container maxWidth="lg" className={'tripInfoDetails'}>
                <DayTripStepper/>
                <div style={{marginTop: 50}}/>
                <Grid container>
                    <Grid item sm={12} md={9} xs={12} sx={{padding:'20px', paddingTop:0}}>
                        <Typography variant="h3" component="h4" className={'tripTitle'}>
                            {selectedActivity ? selectedActivity['name']+' -  ':''}Inquiry Request
                        </Typography>
                        <Container maxWidth={'lg'} style={{minWidth: 350, paddingLeft: 0, paddingRight: 0}} className={classes.root}>
                            <form className={'formPayment'} noValidate onSubmit={handleSubmit}>
                                <Grid container direction="row" justify="center" alignItems="center" style={{paddingBottom: 30}}>
                                    <Grid item xs={6} md={4} style={{padding: 5}}>
                                        <NautilusTextInput fullWidth name="firstname" value={inquiryData['firstname']}
                                                           onChange={handleForm} label="First Name" variant="outlined"/>
                                    </Grid>
                                    <Grid item xs={6} md={4} style={{padding: 5}}>
                                        <NautilusTextInput fullWidth name="lastname" value={inquiryData['lastname']}
                                                           onChange={handleForm} label="Last Name" variant="outlined"/>
                                    </Grid>
                                    <Grid item xs={6} md={4} style={{padding: 5,}}>
                                        <NautilusTextInput fullWidth name="email" value={inquiryData['email']} onChange={handleForm}
                                                           label="Email Address" variant="outlined"/>
                                    </Grid>
                                    <Grid item xs={6} md={4} style={{padding: 5}}>
                                        <NautilusTextInput fullWidth name="phone" value={inquiryData['phone']} onChange={handleForm}
                                                           label="Phone" variant="outlined"/>
                                    </Grid>
                                    <Grid item xs={6} md={4} style={{padding: 5}}>
                                        <NautilusTextInput fullWidth name="guests" value={inquiryData['guests']} onChange={handleForm}
                                                           label="Number of Guests" variant="outlined"/>
                                    </Grid>
                                    <Grid item xs={6} md={4} style={{padding: 5}}>
                                        <NautilusTextInput
                                            fullWidth
                                            name="date"
                                            type="date" // <-- esto es importante
                                            value={inquiryData['date']}
                                            onChange={handleForm}
                                            label="Date"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true, // necesario para que el label no tape el valor
                                            }}
                                        />

                                    </Grid>
                                    <Grid item xs={12} md={6} style={{padding: 5}}>
                                        <NautilusTextInput fullWidth name="inquiryType" value={inquiryData['inquiryType']}
                                                           variant="outlined" select label="Inquire About"
                                                           onChange={handleForm}>
                                            <MenuItem value={''}>
                                                Inquire About
                                            </MenuItem>
                                            {inquiryOptions && inquiryOptions.length > 0 && inquiryOptions.map((option, index) => (
                                                <MenuItem key={index} value={option.title}><span dangerouslySetInnerHTML={{__html: option.title}}/></MenuItem>
                                            ))}

                                        </NautilusTextInput>
                                    </Grid>
                                    <Grid item xs={12} md={6} style={{padding: 5}}>
                                        <NautilusTextInput fullWidth name="interest" value={inquiryData['interest']} variant="outlined"
                                                           select label="I am interested in"
                                                           onChange={handleForm}>
                                            <MenuItem value={''}>
                                                I am interested in
                                            </MenuItem>
                                            <MenuItem value={"This Trip Only"}>This Day Trip Only</MenuItem>
                                            <MenuItem value={"Any Trip This Month"}>Any Day Trip This Month</MenuItem>
                                            <MenuItem value={"Any Sea of Cortez Trip"}>Any Sea of Cortez Day Trip</MenuItem>

                                        </NautilusTextInput>
                                    </Grid>
                                    <Grid item xs={12} style={{padding: 5}}>
                                        <NautilusTextInput fullWidth name="comments" value={inquiryData['comments']}
                                                           placeholder={'Comments, Notes, Requests'} onChange={handleForm} multiline
                                                           rows={4} label="Comments, Notes, Requests" variant="outlined"/>
                                    </Grid>
                                    <Grid item xs={12} style={{padding: 5}}>
                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey={window.recaptchaKey}
                                            size="invisible"
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{padding: 5}}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            fullWidth
                                            className={clsx({[classes.button]: true, 'payButton': true})}
                                            startIcon={<Icon>send</Icon>}
                                        >
                                            Submit Inquiry
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Container>
                    </Grid>
                    <Grid item sm={12} md={3} xs={12}>
                        <Paper style={{marginBottom: 10}}>
                            <Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>
                                Go Back to Select Day Trip
                            </Button>
                        </Paper>
                        {selectedActivity && (<ActivityOverview activity={selectedActivity}/>)}
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};

export default DayTripInquiryPage;